var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFreeAccountIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 76,
    height: 76,
    viewBox: "0 0 76 77",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.2877 63.7545C10.6252 67.4723 13.604 70.1544 17.3317 70.3536C21.6907 70.5865 28.4633 70.8229 38 70.8229C47.5367 70.8229 54.3093 70.5865 58.6683 70.3536C62.396 70.1544 65.3748 67.4723 65.7122 63.7546C65.9781 60.8261 66.2031 56.7919 66.2031 51.5261C66.2031 46.2602 65.9781 42.226 65.7122 39.2975C65.3748 35.5799 62.396 32.8979 58.6683 32.6985C54.3093 32.4656 47.5367 32.2292 38 32.2292C28.4633 32.2292 21.6907 32.4656 17.3317 32.6985C13.604 32.8978 10.6252 35.5799 10.2877 39.2976C10.0219 42.226 9.79688 46.2602 9.79688 51.5261C9.79688 56.7919 10.0219 60.8261 10.2877 63.7545Z",
    stroke: "#E5E7EB",
    strokeWidth: 4,
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M29.6156 32.2951C24.6872 32.3758 20.8204 32.5203 17.9263 32.6677L18.8282 21.8438C19.5975 12.6116 27.3151 5.51044 36.5792 5.51044H39.4245C48.6885 5.51044 56.406 12.6116 57.1754 21.8438L57.3199 23.5785C54.0837 23.4843 50.2757 23.4055 45.8625 23.3612L45.8595 23.3102C45.6148 19.1496 42.1695 15.9011 38.0018 15.9011C33.8342 15.9011 30.3888 19.1496 30.1442 23.3102L29.6156 32.2951Z",
    stroke: "#E5E7EB",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M41.497 52.7651C43.4067 51.5894 44.6797 49.4799 44.6797 47.0729C44.6797 43.3838 41.6891 40.3932 38 40.3932C34.3109 40.3932 31.3203 43.3838 31.3203 47.0729C31.3203 49.4799 32.5933 51.5894 34.503 52.7651L32.5825 59.9668C32.2874 61.0733 32.8942 62.1903 34.0251 62.3706C34.9925 62.5248 36.3175 62.6589 38 62.6589C39.6825 62.6589 41.0075 62.5248 41.9749 62.3706C43.1058 62.1903 43.7126 61.0733 43.4175 59.9668L41.497 52.7651Z",
    stroke: "#E5E7EB",
    strokeWidth: 4,
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFreeAccountIcon);
export default __webpack_public_path__ + "static/media/freeAccountIcon.8b339b105c7afb27e6d9f5512ef5785e.svg";
export { ForwardRef as ReactComponent };